import React from "react";
import "../styles/home.css";
import BottomNav from "../components/BottomNav";
import Navbar from "../components/Navbar";
import { useCart } from "../contexts/CartContext";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const navigate = useNavigate();

  const {
    cartItems,
    removeFromCart,
    updateQuantity,
    getTotalPrice,
    isLoading
  } = useCart();

  return (
    <div className="cart-container">
      <Navbar />

      <h1 className="cart-title">Your Cart</h1>

      {isLoading && <p>Loading your saved cart…</p>}
      <p className="note">Note: your cart is saved only when you're logged in.</p>

      {cartItems.length === 0 ? (
        <p className="empty-cart">Your cart is empty.</p>
      ) : (
        <div className="cart-content">

          {/* CART ITEMS */}
          <div className="cart-items">
            {cartItems.map((item) => (
              <div
                className="cart-item"
                key={item._id}
                onClick={() => navigate(`/product/${item._id}`)}
              >
                <img
                  src={
                    item.images?.[0]?.replace(
                      "/upload/",
                      "/upload/w_400,q_auto,f_auto/"
                    )
                  }
                  alt={item.name}
                  className="cart-item-image"
                  loading="lazy"
                />

                <div className="cart-item-details">
                  <h3>{item.name}</h3>
                  <p>₹{item.price}</p>

                  <div className="quantity-controls">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        updateQuantity(item._id, item.quantity - 1);
                      }}
                    >
                      -
                    </button>

                    <span>{item.quantity}</span>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        updateQuantity(item._id, item.quantity + 1);
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>

                <button
                  className="remove-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFromCart(item._id);
                  }}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>

          {/* CART SUMMARY */}
          <div className="cart-summary">
            <h2>Total: ₹{getTotalPrice()}</h2>
            <button 
              className="checkout-btn"
              onClick={() => navigate("/checkout")}
            >
              Proceed to Checkout
            </button>
          </div>

        </div>
      )}

      <BottomNav />
    </div>
  );
};

export default Cart;